module.exports = __webpack_public_path__ + "img/acreditacion_3.a3772719.png";